import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import quickLink from '@/services/quickLink';
import media from '../styles/media.style';
import Section from './Section';
import { generateKey } from '../utils';

const Links = styled.div`
  background-color: #f2f2f2;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const Item = styled.div`
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  height: 45px;
  line-height: 1.25;
  letter-spacing: 0.5px;
  padding: 15px 12px;
  transition: background-color 100ms ease-in-out, color 100ms ease-in-out;
  white-space: nowrap;
  z-index: 10;

  &:hover {
    background-color: black;
    color: white;
  }

  ${media.tabletL`
    font-size: 13px;
    height: 55px;
    line-height: 1;
    padding: 20px 40px;
  `};
`;

const QuickLinksSection = ({ links, linkHandle }) => (
  <Section options={{ outer: { style: { paddingTop: 0, paddingBottom: 0 } } }}>
    <Links>
      {links.map((link, index) => (
        <Item key={generateKey('header-quick-link', index)} onClick={() => quickLink({ linkHandle, id: link.id })}>
          {link.label}
        </Item>
      ))}
    </Links>
  </Section>
);

QuickLinksSection.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  linkHandle: PropTypes.func.isRequired,
};

export default QuickLinksSection;



// WEBPACK FOOTER //
// ./src/components/QuickLinksSection.js